<template>
  <div class="box-delivery">
      <div class="box-delivery__question">
        <input-label :text="$t('boxDelivery.numberOfBoxesWanted')"></input-label>
        <input-selector v-model="boxOption" :options="boxOptions"/>
      </div>
      <next-transition :visible="showSpecificNumber" class="box-delivery__category">
        <input-label :text="$t('boxDelivery.specificNumberOfBox')"></input-label>
        <box-list v-model="boxCategory"></box-list>
      </next-transition>
  </div>
</template>

<script>

import InputSelector from '@/components/utils/InputSelector.vue';
import InputLabel from '@/components/utils/InputLabel.vue';
import BoxList from '@/components/furnitures/BoxList.vue';
import NextTransition from '@/components/utils/NextTransition.vue';

export default {
  name: 'boxDelivery',
  components: {
    NextTransition,
    BoxList,
    InputLabel,
    InputSelector,
  },
  data() {
    return {
      boxOption: null,
      standardBox: 0,
      booksBox: 0,
      clothBox: 0,
      min: 0,
      boxCategory: [
        {
          name: this.$t('boxConfig.standardBox'),
          size: '55x35x30 cm',
          icon: 'cartons_std',
          quantity: 0,
          max: Infinity,
          min: 0,
          step: 10,
          hide: false,
        },
        {
          name: this.$t('boxConfig.booksBox'),
          size: '35x30x30 cm',
          icon: 'cartons_livre',
          quantity: 0,
          max: Infinity,
          min: 0,
          step: 10,
          hide: false,
        },
        {
          name: this.$t('boxConfig.clothBox'),
          size: '60x55x125 cm',
          icon: 'cartons_penderie',
          quantity: 0,
          max: Infinity,
          min: 0,
          step: 1,
          hide: false,
        },
      ],
    };
  },
  computed: {
    boxOptions() {
      return [
        {
          label: this.$t('boxDelivery.totality'),
          value: 1,
        },
        {
          label: this.$t('boxDelivery.specificNumber'),
          value: 0,
        },
      ];
    },
    showSpecificNumber() {
      return this.boxOption === 0;
    },
    hasPenderies() {
      return this.$store.getters['serviceOfferStore/wardrobes'];
    },
  },
  methods: {
    setBoxCategoryValue() {
      const cartons = this.$store.getters['furnituresStore/cartons'].mover;
      const maxCarton = this.$store.getters['furnituresStore/totalCarton'];
      this.boxCategory[0].quantity = cartons.cartons_std;
      this.boxCategory[0].max = maxCarton.cartons_std;
      this.boxCategory[1].quantity = cartons.cartons_livre;
      this.boxCategory[1].max = maxCarton.cartons_livre;
      this.boxCategory[2].quantity = this.hasPenderies
        ? cartons.cartons_penderie
        : 0;
      this.boxCategory[2].max = maxCarton.cartons_penderie;
      this.boxCategory[2].hide = !this.hasPenderies;
    },
    isAllBoxes() {
      const totalCarton = this.$store.getters['furnituresStore/totalCarton'];
      return this.boxCategory[0].quantity === totalCarton.cartons_std
        && this.boxCategory[1].quantity === totalCarton.cartons_livre
        && (!this.hasPenderies
          || this.boxCategory[2].quantity === totalCarton.cartons_penderie);
    },
  },
  mounted() {
    this.setBoxCategoryValue();
  },
  watch: {
    boxOption(value) {
      if (value === 1) {
        this.$store.commit('furnituresStore/SET_MOVER_CARTON');
        this.setBoxCategoryValue();
      }
    },
    boxCategory: {
      deep: true,
      handler(categories) {
        if (categories[0].quantity >= 0) {
          this.$store.commit('furnituresStore/SET_USER_CARTON', {
            key: 'cartons_std',
            value: categories[0].quantity,
          });
        }

        if (categories[1].quantity >= 0) {
          this.$store.commit('furnituresStore/SET_USER_CARTON', {
            key: 'cartons_livre',
            value: categories[1].quantity,
          });
        }

        if (categories[2].quantity >= 0) {
          this.$store.commit('furnituresStore/SET_USER_CARTON', {
            key: 'cartons_penderie',
            value: categories[2].quantity,
          });
        }

        if (this.isAllBoxes() && this.boxOption === null) {
          this.boxOption = 1;
        } else if (categories[0].quantity
          || categories[1].quantity
          || categories[2].quantity) {
          this.boxOption = 0;
        }
      },
    },
  },
  created() {
    /* if (!this.$store.getters['serviceOfferStore/cartons']) {
      const nextRoute = RouteManager.next(this.$route.path);
      if (nextRoute) this.$router.push(nextRoute);
    } */
  },
};
</script>
